import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Popover } from 'antd';
import PopoverContent from './UserPopoverContent';
// Make sure this points to your NEW simplified pushData file
import { pushData } from '../utilities/pushData'; 

export default function FieldUserBrief({ inspector }) {
  const dispatch = useDispatch();

  // 1. Optimization: We only need the ID of the currently selected inspector
  // to decide if we should highlight the background.
  // We use optional chaining (?.) in case state.inspector is initially null/undefined.
  const selectedInspectorId = useSelector(state => state.inspector?.id);

  const { 
    id, 
    name = 'none', 
    type = 'Field User', 
    icon = `https://picsum.photos/100/100` 
  } = inspector;

  const handleSelectInspector = () => {
    // 2. Dispatch the simplified action creator directly
    dispatch(pushData({ inspector }));
  };

  const isSelected = selectedInspectorId === id;

  return (
    <Popover 
      title="User Information" 
      placement="right" 
      content={<PopoverContent {...{...(inspector || {})}} />}
    >
      <div
        className="user-brief-container flex-row align-center justify-space-between full-width"
        data-testid="button"
        style={{
          // 3. Use the boolean we calculated from Redux state
          background: isSelected ? `rgba(255, 255, 0, 0.3)` : `initial`,
          cursor: 'pointer' // Added this for better UX
        }}
        onClick={handleSelectInspector}
      >
        <div style={{ height: '5rem' }}>
          <img 
            src={icon} 
            alt="field user avatar" 
            className="padding-0-5 height-full border-circle" 
          />
        </div>
        <div className="flex-column" style={{ flex: 5 }}>
          <div>{name}</div>
        </div>
      </div>
    </Popover>
  );
}